export const KINDS = {
  TEXT: 'text',
  TEXTAREA: 'textArea',
  PASSWORD: 'password',
  NUMBER: 'number',
  TEL: 'tel',
  EMAIL: 'email',
  URL: 'url',
} as const

export const SIZES = {
  LARGE: 'Large',
  MEDIUM: 'Medium',
} as const

export const ICON_POSITIONS = {
  LEFT: 'Left',
  RIGHT: 'Right',
} as const

export enum ClusterPosition {
  TOP = 'Top',
  MIDDLE = 'Middle',
  LEFT = 'Left',
  RIGHT = 'Right',
}
